module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAMAAAAc9R5vAAAAG1BMVEVHcEyqVAmqVAisVQeqVQmqVAiqVAirUwmqVQeCsy6nAAAACXRSTlMAquU7/vRRJ2PqzLf3AAAASklEQVR42t3J2Q2AMAwEUWd9JP1XDFJGBMkVwH7Zb+x7G/L36xpciqzjlSFOTwqebqdE4bGdTd0F1wSfsszW9lbwXvBe8F7wX+0CzXwBaXqgyy8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/down-arrow.png
// module id = hEyW
// module chunks = 216